// /********* On scroll heder Sticky *********/
function initHeaderSticky() {
    if (jQuery(document).height() > jQuery(window).height()) {
        if (jQuery('.site-header .main-navigationbar').hasClass("sticky_header")) {
            if (jQuery(this).scrollTop() > 200) {
                jQuery('.site-header .main-navigationbar').addClass("fixed");
            } else {
                jQuery('.site-header .main-navigationbar').removeClass("fixed");
            }
        } else {
            jQuery('.site-header .main-navigationbar').removeClass("fixed");
        }
    }
}
$(document).ready(function () {
    initHeaderSticky()
});
$(window).resize(function () {
    initHeaderSticky()
});
$(window).scroll(function () {
    initHeaderSticky()
});
$(document).ready(function () {
  countDownIni('.flip-countdown,.js-flip-countdown');
  $('body').on('click', '.country-name .nice-select', function (e) {
    e.stopPropagation(); // Stop the event from propagating to the body
    $(this).toggleClass('open');
  });
  $('body').on('click', function (e) {
    $('.country-name .nice-select').removeClass('open');
  });      
  function currencyFormSubmit(event) {
    event.target.form.submit();
  }      
  document.querySelectorAll('.country-name .nice-select .list li').forEach(function (currencyItem) {
    currencyItem.addEventListener('click', function () {
      // Trigger change event on the associated select element
      var selectElement = this.closest('.country-name').querySelector('select');
      if (selectElement) {
        // Set the selected option based on the data-currency attribute of the clicked li
        selectElement.value = this.dataset.currency;
        
        // Trigger change event
        var event = new Event('change', { bubbles: true });
        selectElement.dispatchEvent(event);
  
        // Submit the form
        currencyFormSubmit({ target: selectElement });
      }
    });
  });
 /********* On scroll heder Sticky *********/
    var prevScrollpos = window.pageYOffset;
    window.onscroll = function () {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
            document.getElementById("header-sticky").style.top = "0";
        } else {
            document.getElementById("header-sticky").style.top = "-200px";
        }
        prevScrollpos = currentScrollPos;
    }
    /********* Announcebar hide ********/
    $('#announceclose').click(function () {
        $('.announcebar').slideUp("slow");
    });
    /******  menu hover  ******/
    $(".menu-lnk.has-item").hover(function () {
        $(this).toggleClass("menu_active");
        $(this).find(".menu-dropdown").toggleClass("open_menu");
        $("body").toggleClass("no_scroll");
    });
    /********* Mobile Menu ********/
    $('.mobile-menu-button').on('click', function (e) {
        e.preventDefault();
        setTimeout(function () {
            $('body').addClass('no_scroll active-menu');
            $(".mobile-menu-wrapper").addClass("active-menu");
            $('.overlay').addClass('active');
        }, 50);
    });
    $('body').on('click', '.overlay, .menu-close-icon svg', function (e) {
        e.preventDefault();
        $('body').removeClass('no_scroll active-menu');
        $(".mobile-menu-wrapper").removeClass("active-menu");
        $('.overlay').removeClass('active');
    });
    $('.acnav-label').click(function (e) {
      e.preventDefault();
      var label = $(this);
      var parent = label.parent('.has-children');
      var list = label.siblings('.acnav-list');
      if (parent.hasClass('is-open')) {
          list.slideUp('fast');
          parent.removeClass('is-open');
      }
      else {
          list.slideDown('fast');
          parent.addClass('is-open');
      }
  });
    /**************************/
    // Subscribe popup Js // 
    /**************************/
    if ($('.subscribe-popup').length > 0) {
         $('.subscribe-popup').addClass('active');
         $('body').addClass('no_scroll');
         $(".overlay").addClass("active");
     };
    $('body').on('click', '.overlay , .close-sub-btn', function (e) {
        e.preventDefault();
        $("body").removeClass("no_scroll");
        $(".overlay").removeClass("active");
        $(".subscribe-popup").removeClass("active");
    });
  
  $('body').on('change', '#remember', function (e) {
     setTimeout(function() {
        $("body").removeClass("no_scroll");
        $(".overlay").removeClass("active");
        $(".subscribe-popup").removeClass("active");
      }, 600);      
    });
    /********* mobile stickybar ********/
    $(window).scroll(function () {
        if ($(window).scrollTop() > 300) {
            $(".mobile-stickybar").addClass('show');
        } else {
            $(".mobile-stickybar").removeClass('show');
        }
    });
  
    /********* Cart Popup ********/
       if ($('body').hasClass('cart')) {
            // Disable click on the cart-header div
            $('.main-cart').on('click', function(event) {
                event.preventDefault();
                return false;
            });
        }else{
    
        $('.main-cart').on('click', function (e) {
        e.preventDefault();
            $('body').addClass('no_scroll cartopen');
            $('.overlay').addClass('active');
      });
   }
         

    $(document).on('click', '.overlay, .mini-cart-header .closecart', function (e) {
        e.preventDefault();
        $('.overlay').removeClass('active');
        $('body').removeClass('no_scroll cartopen');
        $('.coupon-popup').removeClass('active');
        $('.gift-popup').removeClass('active');
    });

     /*********coupon popup ********/
  $(document).on('click', '.coupon-icon', function () {
      $(".coupon-popup").toggleClass("active");
    });
     $(document).on('click', '.coupon-icon', function () {
      $(".gift-popup").removeClass("active");
    });
    $(document).on('click', '.close-coupon', function () {
      $(".coupon-popup").removeClass("active");
    });

  // coupan code
    $('body').on('keyup','.discount-coupon', function() {
     var apply_href = $('.apply').attr("href").split('discount=')[0];
     var val = $(this).val();
      $('.apply').attr("href",apply_href+'discount='+val);
       $('.apply').trigger('click');
    });
  
  /*********gift popup ********/
    $(document).on('click', '.gift-icon', function () {
      $(".gift-popup").toggleClass("active");
    });
     $(document).on('click', '.gift-icon', function () {
      $(".coupon-popup").removeClass("active");
    });
    $(document).on('click', '.close-gift', function () {
      $(".gift-popup").removeClass("active");
    });
    

    /********* mobile stickybar ********/
    $(window).scroll(function () {
        if ($(window).scrollTop() > 300) {
            $(".mobile-stickybar").addClass('show');
        } else {
            $(".mobile-stickybar").removeClass('show');
        }
    });

    /*********  ask qustion Popup  ********/
    $(".pro-features li a.ask-qus").click(function () {
        $(".ask-qus-popup").addClass("active");
        $("body").addClass("no_scroll");
        $('.overlay').addClass('active');
    });
    $('body').on('click', '.overlay , .close-btn', function () {
        $(".ask-qus-popup").removeClass("active");
        $("body").removeClass("no_scroll");
        $('.overlay').removeClass('active');
    });


    /*********  Size chart  Popup  ********/
    $(".size-btn").click(function () {
        $(".size-popup").addClass("active");
        $("body").addClass("no_scroll");
        $('.overlay').addClass('active');
    });
    $('body').on('click', '.overlay , .close-btn', function () {
        $(".size-popup").removeClass("active");
        $("body").removeClass("no_scroll");
        $('.overlay').removeClass('active');
    });

    /*********  delivery-popup ********/
    $(".pro-features li a.del-qus").click(function () {
        $(".delivery-popup").toggleClass("active");
        $("body").toggleClass("no_scroll");
        $('.overlay').addClass('active');
    });
    $(".close-btn").click(function () {
        $(".delivery-popup").removeClass("active");
        $("body").removeClass("no_scroll");
        $('.overlay').removeClass('active');
    });

    /*********  Header Search Popup  ********/
    $(".search-header a").click(function () {
        $(".search-popup").toggleClass("active");
        $("body").toggleClass("no_scroll");
        $('.overlay').addClass('active');
        $('body').addClass('search-overlay');
    });
    $(".close-search, .overlay").click(function () {
        $(".search-popup").removeClass("active");
        $("body").removeClass("no_scroll"); +
            $('.overlay').removeClass('active');
        $('body').removeClass('search-overlay');
    });

     // sticky addtocart button

if($('body').hasClass('product')){
$.fn.isInViewport = function() {
    var elementTop = this.offset().top;
    var elementBottom = elementTop + this.outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

    $(window).scroll(function() {
        if ($('.cart-btn.product-button').isInViewport()) {
          $('.products-add-cart-sticky').removeClass('show_btn');
        } else {
          $('.products-add-cart-sticky').addClass('show_btn');
        }
    });
    }

   $(".stickyOpt.nice-select").on('click', function(){
		$(this).toggleClass('open');
    });
    $(".stickyOpt .vrOpt").on('click', function(e){
        var sectionId = $('.pdp-page-main-sec').attr('data-section-id');
		var number = $(this).data('no');
        $(".stickyOpt .selectedOpt").html($(this).html());
      	$(this).toggleClass('open');
      	this.productvariants = JSON.parse(document.getElementById('variants'+sectionId).innerHTML);
        var stOpt = this.productvariants[number],
            o1 = stOpt.option1, o2 = stOpt.option2, o3 = stOpt.option3;
        $('.stickCtImg').attr('src', stOpt.featured_image.src+'&width=100');
        if($('select.single-option-selector').length){
        } else {
            if(o2 != null){var stOpt2 = o2.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt2+"']").prop("checked",true)}
            if(o3 != null){var stOpt3 = o3.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt3+"']").prop("checked",true)}
            if(o1 != null){var stOpt1 = o1.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt1+"']").trigger('click')}
        }
    });
  
      $(".stickyQty .quantity__button").on("click", function(){
      var qtyField = $('.mianQty'),oldValue = $(qtyField).val(),newVal = 1;
      if ($(this).is(".quantity-increment")) {
        newVal = parseInt(oldValue) + 1;
      } else if (oldValue > 1) {
        newVal = parseInt(oldValue) - 1;
      }
      $(qtyField).val(newVal).trigger('change');
    });
    $('.mianQty').on("change", function(){
      $('#stquantity').val($(this).val());
    });
// end sticky
  
/********* Mobile Filter Popup ********/
    $('.mobile-facets__open').on('click', function (e) {
      $('body').addClass('mobile-open no_scroll');
      $('.overlay').addClass('active');
    });
    $('.overlay,.close-filter,.apply-btn').on('click', function (e) {
      $('body').removeClass('mobile-open no_scroll overflow-hidden-mobile');
      $('.overlay').removeClass('active');
    }); 

function responsiveMenu(){
  if(jQuery(window).width() < 768) {
    $('.product-filter-column').prependTo('.product-heading-row .container .row .product-heading-column');
  }
  else { 
    $('.product-filter-column').prependTo('.product-list-row');
    if($('body').hasClass('mobile-open') ){
      $('body').removeClass('mobile-open no_scroll overflow-hidden-mobile');
      $('.overlay').removeClass('active');
     }
    
  }

      if(jQuery(window).width() < 992) {
     if(!$('.mobile-lag').length > 0 ){
      const newDiv = document.createElement('div');
      newDiv.className = 'mobile-lag d-flex align-items-center';
      $(newDiv).insertAfter('.menu-close-icon');
      $('.country-name, .languages').prependTo('.mobile-lag');
    }else{
       return false;
    }
  }
  else {
    $('.country-name, .languages').prependTo('.announcebar-right');
    $('.mobile-lag').remove();
  }
  
}
    responsiveMenu();
  jQuery(window).resize(function() {
    responsiveMenu();
  });

   /********* category product ********/
    $(".list-view").click(function () {
      $(".list-view").addClass("active");
      $(".grid-view").removeClass("active");

      $(".grid-product .row").addClass("product-list-view");
      $(".grid-product .row").removeClass("product-grid-view");

      jQuery('.product-list-view > .grid__item').each(function() {  
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content-top').insertAfter(prod_img);

        var prod_lable = jQuery(this).find('.product-content');
        jQuery(this).find('.product-content-top').prependTo(prod_lable);
        
        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-label-wrp').prependTo(prod_lable);

        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('h3').appendTo(prod_lable); 
          
        var coll_count = jQuery(this).find('h3');
        jQuery(this).find('.product-content-top p').insertAfter(coll_count);
          
        var coll_count = jQuery(this).find('.product-content-top');
        jQuery(this).find('.time-counter').appendTo(coll_count);
          
        var prod_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(prod_right);

        var prod_rev = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.rating-wrp').prependTo(prod_rev);  

        var prod_form = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.price').appendTo(prod_form);  
        
        var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_pri = jQuery(this).find('.price');
        jQuery(this).find('.color-variant-swatch').insertAfter(prod_pri);

        var prod_add = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').appendTo(prod_add);       
      });
    });
    $(".grid-view").click(function () {
      $(".grid-view").addClass("active");
      $(".list-view").removeClass("active");

      $(".grid-product .row").addClass("product-grid-view");
      $(".grid-product .row").removeClass("product-list-view");

      jQuery('.product-grid-view > .grid__item').each(function() {
        
        var div_con = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content').insertAfter(div_con);
        
        var div_left = jQuery(this).find('.product-content');
        jQuery(this).find('.product-content-top').prependTo(div_left);

        var div_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(div_right);

        var prod_title = jQuery(this).find('.product-content-top');
        jQuery(this).find('.rating-wrp').appendTo(prod_title);

        var timer_btn = jQuery(this).find('.rating-wrp');
        jQuery(this).find('h3').prependTo(timer_btn);

        var timer_btn = jQuery(this).find('.rating-wrp');
        jQuery(this).find('p').appendTo(timer_btn);
        
        var prod_rew = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.price').prependTo(prod_rew);

        var prod_btn = jQuery(this).find('.price');
        jQuery(this).find('.color-variant-swatch').insertAfter(prod_btn);  

        var prod_label = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_label);

        var prod_btn2 = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-label-wrp').appendTo(prod_btn2); 
        
        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-form').prependTo(prod_btn);
        
      });
    });
  
    /** footer acnav **/
    $('.acnav-label1').click(function (event) {
        event.preventDefault();
        if (jQuery(window).width() < 768) {
            var label = $(this);
            var parent = label.parent('.has-children1');
            var list = label.siblings('.acnav-list1');

            // Close any open lists
            $('.has-children1.is_open').not(parent).removeClass('is_open').children('.acnav-list1').slideUp('fast');

            if (parent.hasClass('is_open')) {
                list.slideUp('fast');
                parent.removeClass('is_open');
            }
            else {
                list.slideDown('fast');
                parent.addClass('is_open');
            }
        }
    });

    /****  TAB Js ****/
    $("ul.tabs li").click(function () {
        var $this = $(this);
        var $theTab = $(this).attr("data-tab");
        if ($this.hasClass("active")) {
        } else {
            $this
                .closest(".tabs-wrapper")
                .find("ul.tabs li, .tab-content, .tab-image")
                .removeClass("active");
            $(
                '.tab-content[id="' +
                $theTab +
                '"], ul.tabs li[data-tab="' +
                $theTab +
                "]"
            ).addClass("active");
        }
        $(this).addClass("active");
    });

    // home banner slider

    var swiper = new Swiper(".home-banner-slider", {
        slidesPerView: 3,
        spaceBetween: 15,
        loop: true,
        speed: 800,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        breakpoints: {
            992: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 2,
            },
            320: {
                slidesPerView: 1,
            }
        }
    });

});

// Trending Products slider 
var swiper = new Swiper(".trending-product-slider", {
    spaceBetween: 20,
    slidesPerColumn: 2,
    slidesPerView: 4,
    speed: 800,
    grid: {
        rows: 2,
    },
    navigation: {
        nextEl: ".product-arrow.swiper-button-next",
        prevEl: ".product-arrow.swiper-button-prev",
    },
    breakpoints: {
        1200: {
            slidesPerView: 4,
            grid: {
                rows: 2,
            },
        },
        1024: {
            slidesPerView: 3,
            grid: {
                rows: 2,
            },
        },
        768: {
            slidesPerView: 3,
            grid: {
                rows: 2,
            },
        },
        575: {
              slidesPerView: 2,
              grid: {
                  rows: 1,
              },
          },
          320: {
              slidesPerView: 1,
              grid: {
                  rows: 1,
              },
          },
          0: {
              slidesPerView: 1,
              grid: {
                  rows: 1,
              },
          },
    },
});

/** Products slider **/
var swiper = new Swiper(".product-slider", {
    spaceBetween: 20,
    slidesPerColumn: 2,
    slidesPerView: 4,
    speed: 800,
    grid: {
        rows: 2,
    },
    navigation: {
        nextEl: ".product-arrow.swiper-button-next",
        prevEl: ".product-arrow.swiper-button-prev",
    },
    breakpoints: {
        1200: {
            slidesPerView: 4,
            grid: {
                rows: 2,
            },
        },
        1024: {
            slidesPerView: 3,
            grid: {
                rows: 2,
            },
        },
        768: {
            slidesPerView: 3,
            grid: {
                rows: 2,
            },
        },
        575: {
              slidesPerView: 2,
              grid: {
                  rows: 1,
              },
          },
          320: {
              slidesPerView: 1,
              grid: {
                  rows: 1,
              },
          },
          0: {
              slidesPerView: 1,
              grid: {
                  rows: 1,
              },
          },
    },
});

// Product Slider

var swiper = new Swiper(".tabs-product-slider", {
    spaceBetween: 20,
    slidesPerView: 2,
    speed: 800,
    breakpoints: {
        1200: {
            slidesPerView: 2,
            grid: {
                rows: 2,
            },
        },
        768: {
            slidesPerView: 1,
            grid: {
                rows: 2,
            },
        },
    },
});

/*** testimonial slider **/
var swiper = new Swiper(".testimonial-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 800,
    loop: true,
    navigation: {
        nextEl: ".testimonial-arrow.swiper-button-next",
        prevEl: ".testimonial-arrow.swiper-button-prev",
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
        },
    },
});

//***** Blog Slider

var swiper = new Swiper(".blog-slider", {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
        nextEl: ".blog-arrow.swiper-button-next",
        prevEl: ".blog-arrow.swiper-button-prev",
    },
    breakpoints: {
        992: {
            slidesPerView: 3,
        },
        576: {
            slidesPerView: 2,
        },
        0: {
            slidesPerView: 1,
        },
    },
});

      // product slider zoom
    $('.product-item-img.zoom').each(function() {
      $(this).zoom({
        url: false,
        callback: false,
        target: false,
        duration: 120,
        on: 'mouseover', // other options: grab, click, toggle
        touch: true, // enables a touch fallback
        onZoomIn: false,
        onZoomOut: false,
        magnify: 2
      });
    });

// bottom-main-slider
var sliderThumbnail = new Swiper(".bottom-thumbslider", {
    slidesPerView: 5,
    spaceBetween: 10,
    centeredSlides: false,
    centeredSlidesBounds: true,
    watchOverflow: true,
    watchSlidesVisibility: false,
    watchSlidesProgress: false,
    breakpoints: {
        992: {
            slidesPerView: 5,
        },
        768: {
            slidesPerView: 3,
        },
        576: {
            slidesPerView: 4,
        },
        0: {
            slidesPerView: 3,
        },
    },
});

var swiper = new Swiper(".bottom-main-slider", {
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    preventInteractionOnTransition: true,
    navigation: {
        nextEl: '.bottom-thumb-arrow.swiper-button-next',
        prevEl: '.bottom-thumb-arrow.swiper-button-prev',
    },
    thumbs: {
        swiper: sliderThumbnail
    }
});

/**************************/
/** counter js **/
/**************************/

$('.counting').each(function () {
    var $this = $(this),
        countTo = $this.attr('data-count');

    $({ countNum: $this.text() }).animate({
        countNum: countTo
    },

        {
            duration: 3000,
            easing: 'linear',
            step: function () {
                $this.text(Math.floor(this.countNum));
            },
            complete: function () {
                $this.text(this.countNum);
            }

        });
});

   // notify me
    $('body').on('click','.notify-btn', function(e) {
        e.preventDefault();
        $('body').addClass('no_scroll notify-active');
        $('.out-of-stock-form,.overlay').addClass('active');
      });
     $('body').on('click','.overlay,.notify-popup-close', function(e) {
        e.preventDefault();
       $('body').removeClass('no_scroll notify-active');
        $('.out-of-stock-form,.overlay').removeClass('active');
      });

   /******* quick-view-popup Js *******/

  $(".quick-close-btn").click(function () {
    $(".quick-view-popup").removeClass("active");
    $("body").removeClass("no_scroll");
  });
  $('body').on('click', '.quickview-btn', function(e) {
    e.preventDefault();
    var href= '/products/'+$(this).data('handle')+'?view=qv';
    $.get(href, function(product) {
      $('.quickview_popup_data').html(product);
       var swiper = new Swiper(".quickview-img-slider", {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        speed: 800,
        navigation: {
            nextEl: ".quickview-arrow.swiper-button-next",
            prevEl: ".quickview-arrow.swiper-button-prev",
        },
    });    
    });
    $(".quick-view-popup").toggleClass("active");
    $("body").toggleClass("no_scroll");
  });
  
$('body').on('click', '.quickview_popup_data .color-variant-swatch .button', function() {
  var data_val = $(this).children('input:checked').val();
   $(this).parents('.color-variant-swatch').find('.option-label').text(data_val);
  
  var selectedValues = [];

  // Collect selected option values
  $('.quickview_popup_data .color-variant-swatch .button input:checked').each(function() {
    var selectedValue = $(this).val();
    
    if (selectedValue) {
      selectedValues.push(selectedValue);
    }
  });
var joinedValues = selectedValues.join(' / ');

  $('.variant-qv').each(function() {
    var variant_title = $(this).data('title');
    var variant_img = $('.variant-qv[data-title="'+variant_title+'"]').data('img');
    var variant_price = $('.variant-qv[data-title="'+variant_title+'"]').data('price');
    var qv_btn =  $('.variant-qv[data-title="'+variant_title+'"]').data('avail');
    var variant_id = $('.variant-qv[data-title="'+variant_title+'"]').data('id');

    // Check if variant_title exists in the selectedValues array
    if(variant_title === joinedValues){
      
      var variantImageIndex = $('.quickview-img-slider .quickview-card-image img[data-img="'+variant_img+'"]').parents('.qv-pro-slider-img').index();
      new Swiper('.quickview-img-slider').slideTo(variantImageIndex);

      $('.qv-price').find('.price-item--regular').text(variant_price);

      if (qv_btn === true) {
         $('.quickview_popup_data .product-form__submit').find('span').text('Add To Cart');
        $('.quickview_popup_data .product-form__submit').removeAttr('disabled');
      } else {
        $('.quickview_popup_data .product-form__submit').find('span').text('Sold out');
        $('.quickview_popup_data .product-form__submit').attr('disabled', 'disabled');
         $('.quickview_popup_data .product-form__submit > svg').remove();
      }

      $('input[name="id"]').val(variant_id);
    }
  });
});
/**************************/
// progress-wrap Js // 
/**************************/
function scrollIndicator() {
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const windowHeight = document.documentElement.clientHeight;
    const maxScrollTop = scrollHeight - windowHeight;
    const scrollPointBottom = $('.scroll-line').outerHeight();
    const scrollPointPos = (scrollTop * scrollPointBottom) / maxScrollTop;
    if (scrollTop > 200) {
        $('.scroll-progress').addClass('visible');
    } else {
        $('.scroll-progress').removeClass('visible');
    }
    anime({
        targets: '.scroll-point',
        perspective: '500px',
        translateX: 0,
        translateY: scrollPointPos,
        translateZ: '0',
        easing: 'easeOutCirc'
    });
}
$(document).ready(function () {
    // Initial call on document ready
    scrollIndicator();

    // Attach scroll event listener
    $(document).scroll(function () {
        scrollIndicator();
    });
});
function countDownIni(countdown) {
 $(countdown).each(function () {
   var countdown = $(this);
   var promoperiod;
   if (countdown.attr('data-promoperiod')) {
     promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
   } else if (countdown.attr('data-countdown')) {
     promoperiod = countdown.attr('data-countdown');
   }
   if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
     $(this).addClass('countdown-block');
     countdown.countdown(promoperiod, function (event) {
       countdown.html(event.strftime("<div class='counter'><span class='count count-days'>%D</span><span class='counter-dtl'>days</span></div>" + "<div class='counter'><span class='count count-hours'>%H</span><span class='counter-dtl'>hrs</span></div>" + "<div class='counter'><span class='count count-minites'>%M</span><span class='counter-dtl'>mins</span></div>" + "<div class='counter'><span class='count count-seconds'>%S</span><span class='counter-dtl'>secs</span></div>"));
     });
   }
    if (Date.parse(promoperiod) - Date.parse(new Date()) < 0) {
        $(this).parent().css('display','none');
        $(this).parents('.pdp-timer').css('display','none');
     }
 });
}